import { FamilyRegistrationService } from './../../../shared-modules/family-registration/family-registration.service';
import { UserService } from './../../user/user.service';
import {Injectable} from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot, CanActivate, Router } from '@angular/router';
import { Observable } from 'rxjs';


@Injectable()
export class NewFamilyRegistrationGuard implements CanActivate {

    // Instance Properties

    // Class Functions
    constructor(
        private userService: UserService,
        private familyRegistrationService: FamilyRegistrationService,
        private router: Router
    ) { }

    // Methods
    canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {
        // PRE: the user tries to navigate to a route guarded by this
        // POST: checks that the new family registration is true
        if (this.userService.currentUser && this.userService.currentUser.NewFamilyRegistration) {
            return true;
        } else if (this.familyRegistrationService.householdParent) {
            return true;
        } else {
            this.router.navigateByUrl('/login');
            return false;
        }
    }
}
